import {
  PaginatedWidgetAvatarTemplate,
  Template,
  TemplateType,
  TemplateSubType,
  TemplateVisualEditor,
  WidgetAvatarTemplate,
  SocialImageSize
} from '@app/modules/shared/models';
import {PaginatedTemplateRevisions} from '@app/modules/shared/models/template-revision';

export interface ITemplateState {
  template: Template;
  templates: Template[];
  templateCampaign: any;
  templateTypes: TemplateType[];
  templateSubTypes: TemplateSubType[];
  visualEditors: TemplateVisualEditor[];
  socialImageSizes: SocialImageSize[];
  templateRevisions: PaginatedTemplateRevisions;
  previewUrl: any;
  widgetPreviewUrl: any;
  widgetCustomScriptBody: any;
  widgetAvatarTemplate: WidgetAvatarTemplate;
  widgetAvatarTemplates: WidgetAvatarTemplate[];
  paginatedWidgetAvatarTemplates: PaginatedWidgetAvatarTemplate;
  widgetAvatars: any;
  success: string;
  error: string;
}

export const initialTemplateState: ITemplateState = {
  template: null,
  templates: [],
  templateTypes: [],
  templateSubTypes: [],
  visualEditors: [],
  socialImageSizes: [],
  templateCampaign: null,
  templateRevisions: null,
  previewUrl: null,
  widgetPreviewUrl: null,
  widgetCustomScriptBody: null,
  widgetAvatarTemplate: null,
  widgetAvatarTemplates: null,
  paginatedWidgetAvatarTemplates: null,
  widgetAvatars: [],
  success: '',
  error: ''
};
